import { faPlus } from "@fortawesome/free-solid-svg-icons"
import Button from "components/Shared/Button/Button"

interface HeaderCTAProps {
  label: string
  onClick: () => void
}

export default function HeaderCTA({ onClick, label }: HeaderCTAProps) {
  return <Button action={onClick} label={label} className="btn-full green" icon={faPlus} />
}
